'use strict';

angular
  .module('AdminSystemOwnerReviewControllers')

  .controller('AdministrationController', [
    '$scope',
    '$state',
    '$translate',
    'topBar',
    'currentPeriod',
    'authenticatedUser',
    'systemOwnersAndChanges',
    'systemOwnerReviewProcesses',
    function (
      $scope,
      $state,
      $translate,
      topBar,
      currentPeriod,
      authenticatedUser,
      systemOwnersAndChanges,
      systemOwnerReviewProcesses
    ) {
      $scope.currentPeriod = currentPeriod;
      $scope.currentUserIdentity = authenticatedUser.IdentityName;
      $scope.systemOwnerReviewProcesses = systemOwnerReviewProcesses;

      $translate('iam.admin.systemOwnerReview.pageTitle', { name: currentPeriod.Name }).then(function (translation) {
        topBar.setTitleAndIcon(translation, 'fa-eye');
      });

      $scope.resetFilter = function () {
        $scope.filteredProcess = null;
        $scope.search = null;
        $scope.filterByNoReminderSent = false;
        $scope.filteredSystemOwners = systemOwnersAndChanges;
      };
      $scope.resetFilter();

      var countByProcessId = _.countBy(systemOwnersAndChanges, 'SystemOwnerReviewProcessID');

      $scope.systemTypesToReview = function (systemOwnerAndChanges) {
        return _.chain(systemOwnerAndChanges.SystemInfos)
          .groupBy('SystemTypeID')
          .map(function (systems, systemTypeId) {
            var firstSystem = systems[0];
            return {
              SystemTypeID: firstSystem.SystemTypeID,
              SystemTypeName: firstSystem.SystemTypeName,
              SystemCssIcon: firstSystem.SystemCssIcon,
              Systems: systems,
            };
          })
          .value();
      };

      $scope.getNbEmployees = function (systemOwnerReviewProcess) {
        var processId = systemOwnerReviewProcess.SystemOwnerReviewProcessID;
        if (!countByProcessId.hasOwnProperty(processId)) return 0;
        return countByProcessId[processId];
      };

      $scope.getNbEmployeesNoReminder = function (systemOwnerReviewProcess) {
        return countByProcessId[processId];
      };

      $scope.changeFilteredProcess = function (systemOwnerReviewProcess) {
        var processId = systemOwnerReviewProcess.SystemOwnerReviewProcessID;
        $scope.filteredProcess = processId;
        $scope.filterByNoReminderSent = false;
        $scope.filteredSystemOwners = _.filter(systemOwnersAndChanges, { SystemOwnerReviewProcessID: processId });
      };

      $scope.isSelectedProcess = function (systemOwnerReviewProcess) {
        if (_.isUndefined(systemOwnerReviewProcess)) return false;
        var processId = systemOwnerReviewProcess.SystemOwnerReviewProcessID;
        return processId === $scope.filteredProcess;
      };

      // No Reminder sent
      $scope.noReminderSent = {};
      $scope.noReminderSent.nbEmployees = _.filter(systemOwnersAndChanges, function (systemOwner) {
        return _.isUndefined(systemOwner.LastReminderSent);
      }).length;

      $scope.noReminderSent.filter = function () {
        $scope.filteredProcess = undefined;
        $scope.filterByNoReminderSent = true;
        $scope.filteredSystemOwners = _.filter(systemOwnersAndChanges, function (systemOwner) {
          return _.isUndefined(systemOwner.LastReminderSent);
        });
      };
    },
  ]);
